/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_View_ClientInputs */

const en_users_detail_view_client = /** @type {(inputs: Users_Detail_View_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Client`)
};

const pt_br2_users_detail_view_client = /** @type {(inputs: Users_Detail_View_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Cliente`)
};

/**
* | output |
* | --- |
* | "View Client" |
*
* @param {Users_Detail_View_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_view_client = /** @type {((inputs?: Users_Detail_View_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_View_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_view_client(inputs)
	return pt_br2_users_detail_view_client(inputs)
});